import { render, staticRenderFns } from "./haveDinnerPage.vue?vue&type=template&id=c54a5fbe&"
import script from "./haveDinnerPage.vue?vue&type=script&lang=js&"
export * from "./haveDinnerPage.vue?vue&type=script&lang=js&"
import style0 from "./haveDinnerPage.vue?vue&type=style&index=0&id=c54a5fbe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports